import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs/Observable';
import { Headers, Http } from '@angular/http';
import { Router } from '@angular/router';
import { saveAs } from 'file-saver/FileSaver';
import { ApiEvsService } from 'app/common/services/ApiEvs.service';
import { HttpHeaders } from '@angular/common/http';

@Injectable()
export class ActiveTempNewService {
  headers: Headers;
  httpHeaders: HttpHeaders
  url = environment.api_evs;
  url2 = environment.api_evs + '/qr-core-aps';

  constructor(private http: Http, private router: Router, private apiEvsService: ApiEvsService) {
    const token = localStorage.getItem('Access-Token');
    this.headers = new Headers({
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    });
    this.httpHeaders = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    })
  }


  batchSeperateValidate(body?: any): Observable<any> {
    return this.http
      .post(`${this.url}/qr_aps/batch/seperate/validate`, body, {
        headers: this.headers,
      })
      .map((res) => {
        return res.json();
      })
      .catch((error: any) => {
        throw error.json();
      });
  }

  batchSeperate(body?: any): Observable<any> {
    return this.http
      .post(`${this.url}/qr-core-aps/batch/seperate`, body, {
        headers: this.headers,
      })
      .map((res) => {
        return res.json();
      })
      .catch((error: any) => {
        throw error.json();
      });
  }

  // tslint:disable-next-line:comment-format
  //Import batch by serial
  uploadFileBatchSerial(body?: any): Observable<any> {
    if (!this.headers.has('Content-Type')) {
      this.headers.set('Content-Type', 'application/json');
    }
    if (localStorage.getItem('Access-Token')) {
      this.headers.set('authorization', localStorage.getItem('Access-Token'));
    }
    const lang = localStorage.getItem('lang') || 'vi';
    this.headers.set('Accept-Language', lang);
    return this.http
      .post(`${this.url2}/batch/import/serial`, body, { headers: this.headers })
      .map((res) => {
        return res.json();
      })
      .catch((error: any) => {
        throw error.json();
      });
  }

  // tslint:disable-next-line:comment-format
  //Kích hoạt tem bằng cách import file excel theo số lượng sản phẩm
  uploadFileNumberProduct(body?: any): Observable<any> {
    if (!this.headers.has('Content-Type')) {
      this.headers.set('Content-Type', 'application/json');
    }
    if (localStorage.getItem('Access-Token')) {
      this.headers.set('authorization', localStorage.getItem('Access-Token'));
    }
    const lang = localStorage.getItem('lang') || 'vi';
    this.headers.set('Accept-Language', lang);
    return this.http
      .post(`${this.url2}/batch/separate/import`, body, { headers: this.headers })
      .map((res) => {
        return res.json();
      })
      .catch((error: any) => {
        throw error.json();
      });
  }

  // detailAgencies(id): Observable<any> {
  //   return this.http
  //     .get(`${this.url}/agencies/${id}`, { headers: this.headers })
  //     .map((res) => {
  //       return res.json();
  //     })
  //     .catch((error: any) => {
  //       throw error.json();
  //     });
  // }
  //    Tuanba:17/08/2022: Validate lo step1 lô tem

  validateStep1(body?: any): Observable<any> {
    return this.http
      .post(`${this.url}/qr-core-aps/batch/separate/validate`, body, {
        headers: this.headers,
      })
      .map((res) => {
        return res.json();
      })
      .catch((error: any) => {
        throw error.json();
      });
  }

  getBlockchainInfo(): Observable<any> {
    return this.http
      .get(`${this.url2}/account/blockchain-info`, {
        headers: this.headers,
      })
      .map((res) => res.json())
      .catch((error: any) => {
        throw error.json();
      });
  }

  //TuanBa validate and export

  public getDownloadExcelError(query) {
    return this.apiEvsService.getExcel2('/qr-core-aps/batch/separate/validate/export', query)
  }

  downloadExcelError(prefix: any, idStart: any, idEnd: any): Observable<any> {
    return this.http
      .get(`${this.url}/qr-core-aps/batch/separate/validate/export?prefix=${prefix}&idStart=${idStart}&idEnd=${idEnd}`, {
        headers: this.headers,
        // responseType: 'blod'
      })
      .map((res) => {
        return res;
      })
      .catch((error: any) => {
        throw error;
      });
  }
  public saveToFileSystem(response, __type, filename) {
    const contentDispositionHeader: string = response.headers.get('Content-Disposition');
    if (contentDispositionHeader !== null) {
      const parts: string[] = contentDispositionHeader.split(';');
      //const filename = parts[1].split('=')[1];
      const blob = new Blob([response._body], { type: __type });
      console.log(111, blob)
      saveAs(blob, filename);
    } else {
      // handling download condition if content disposition is empty
      const blob = new Blob([response._body], { type: __type });
      console.log(222, blob)
      saveAs(blob, filename);
    }
  }

}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/qrcode/share/ActiveTempNew/services/ActiveTempNew.service.ts